<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div>
      <!-- dialog common header -->
      <popup-header
        v-bind:headerSaveBtn="headerSaveBtnName"
        v-on:clickSave="doSave"
        v-on:clickClose="closeModal()"
      ></popup-header>
      <!-- 제목 -->
      <v-row class="title-wrap">
        <v-col cols="12" class="big-title">담당자 추가</v-col>
      </v-row>
      <!-- 추가버튼 -->
      <v-row class="ma-0 mb-3">
        <v-col cols="12" class="py-0 px-6">
          <v-btn
            color="white"
            block
            height="48"
            elevation="0"
            class="btn-add"
            @click="onOffModal(callModalName)"
          >
            담당자 추가
            <v-icon class="ml-auto" color="#a4abb2">mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- 담당자 리스트 -->
      <v-row class="ma-0">
        <v-col class="px-6 pt-2">
          <v-list class="order-list">
            <draggable v-model="mgrUserListCopy" handle=".drag-handle">
              <v-list-item-group
                v-for="mgrItem in mgrUserListCopy"
                :key="mgrItem.mgrSabun"
              >
                <v-list-item class="px-4">
                  <v-list-item-icon @click="deleteEmp(mgrItem)">
                    <v-icon>mdi-close</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title
                      ><span class="name" v-text="mgrItem.name"></span
                      ><span
                        class="sub-desc ml-2"
                        v-text="mgrItem.mgrJikchakNm"
                      ></span
                      ><span
                        class="sub-desc divider"
                        v-text="mgrItem.mgrOrgNm"
                      ></span
                    ></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-icon class="ml-auto drag-handle">
                    <v-icon>mdi-menu</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list-item-group>
            </draggable>
          </v-list>
        </v-col>
      </v-row>

      <!-- [모달] 임직원검색 -->
      <search-executives-dialog
        v-on:clickEmpSelect="addEmp"
      ></search-executives-dialog>
    </div>
  </v-dialog>
</template>

<script>
import SearchExecutivesDialog from '@/components/application/dialog/SearchExecutivesDialog.vue'; // 임직원검색 modal component
import PopupHeader from '@/components/common/PopupHeader.vue'; // dialog Header component

import { mapGetters } from 'vuex';
import Draggable from 'vuedraggable';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

export default {
  mixins: [dialogMixin],

  props: {
    mgrUserListProps: {
      type: [],
    },
  },
  data: () => ({
    modalName: 'add_mgrrer',
    callModalName: 'search_executives',
    headerSaveBtnName: '추가',
    mgrUserListCopy: [],
    idx: 1,
  }),
  watch: {
    // 현재참조자목록 복사 (props로 받은 값은 변경할 수 없음)
    mgrUserListProps() {
      this.mgrUserListCopy = this.mgrUserListProps;
    },
  },
  computed: {
    ...mapGetters('ELA', ['GET_APPL_USER_LIST', 'GET_MGR_USER_LIST', 'GET_ORG_LEVEL']),
  },
  methods: {
    /* 결재선 임직원추가 */
      addEmp(employee) {

      // 중복검사
      const dupResult = this.mgrUserListCopy.filter(
        user => user.mgrSabun == employee.sabun,
      );

      if (dupResult != '') {
        alert('이미 담당자로 추가된 임직원입니다');
        return;
      }

      // 담당자에 추가
      this.mgrUserListCopy.push({
        /*
        agreeSeq: this.mgrUserListCopy.length
          ? this.mgrUserListCopy.length + 1
          : 1,
        */

        /*
        agreeSeq: this.GET_MGR_USER_LIST[this.GET_MGR_USER_LIST.length - 1]!==undefined?
          this.GET_MGR_USER_LIST[this.GET_MGR_USER_LIST.length - 1].agreeSeq + this.idx++ : this.GET_APPL_USER_LIST.length + this.idx,
        */

        agreeSeq: this.GET_APPL_USER_LIST.length + this.GET_MGR_USER_LIST.length + this.idx++,
        name: employee.name,
        mgrSabun: employee.sabun,
        mgrJikwee: employee.jikweeNm,
        mgrJikweeNm: employee.jikweeNm,
        mgrJikchakNm: employee.jikchakNm,
        mgrOrgNm: employee.orgNm,
        mgrJikchak: employee.jikchakNm,
        mgrOrg: employee.orgNm,
        applTypeCd: '40',
        gubun: '3',
        orgAppYn: 'N',
        pathSeq: this.GET_ORG_LEVEL,

        inSabun: this.GET_APPL_USER_LIST[0].agreeSabun,
        inOrg: this.GET_APPL_USER_LIST[0].org,
        inJikchak: this.GET_APPL_USER_LIST[0].jikchak,
        inJikwee: this.GET_APPL_USER_LIST[0].jikwee,
      });

      // 모달닫기
      this.onOffModal(this.callModalName);
    },

    /* 결재선 임직원삭제 */
    deleteEmp(employee) {
      this.mgrUserListCopy.forEach((item, index) => {
        if (item.mgrSabun == employee.mgrSabun) {
          this.mgrUserListCopy.splice(index, 1);
        }
      });
    },

    /* 변경내용저장 */
    doSave() {
      this.$store.commit('ELA/SET_MGR_USER_LIST', this.mgrUserListCopy);
      this.closeModal();
    },

    /* 모달호출 */
    onOffModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
    },
  },
  components: {
    PopupHeader,
    SearchExecutivesDialog,
    Draggable,
  },
};
</script>
<style>
.v-btn.btn-add {
  border-radius: 12px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12) !important;
  font-size: 1rem;
}
</style>
